<template>
  <div
    :class="`snackbar__${position} snackbar__${type}`"
    :id="`snackbar-${id}`"
    class="flex justify-between print-hidden snackbar"
  >
    <div
      class="
        flex
        items-center
      "
    >
      <i
        :class="icon"
        class="text-xl mr-4"
      />
      <section class="
        flex
        flex-col
      ">
        <span v-if="title" class="mb-1">
          {{ title }}
        </span>
        <span class="font-light text-sm">
          {{ msg }}
        </span>
      </section>
    </div>
    <div class="flex snackbar__close">
      <w-button
        v-if="showClose"
        class="ml-2 px-2 py-0"
        variant="icon"
        @click="close"
      >
        <i class="icon-cross" />
      </w-button>
    </div>
  </div>
</template>

<script>
import Snackbar from './Snackbar';

export default Snackbar;
</script>

<style lang="scss" scoped>
@import 'Snackbar';
</style>
